module.exports = __webpack_public_path__ + "ac174d9ed288bd973da4e08335177784.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/images/avatar-morris.svg
// module id = ./src/components/Home/images/avatar-morris.svg
// module chunks = 2